import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import styles from './Supplement.module.scss';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalView: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 'none',
    width: '100%',
    maxWidth: '800px',
    borderRadius: '5px',
    maxHeight: '90%',
    overflow: 'scroll',
  },
}));

export default function Supplement({ handleOpenClose, open }) {
  const classes = useStyles();

  const facts = () => {
    return (
      <div className={styles.container}>
        <div className={styles.buttonContainer}>
          <button className={styles.closeButton} onClick={handleOpenClose}>
            {' '}
            X{' '}
          </button>
        </div>
        <h4 className={styles.header}>ICARIIN</h4>
        <hr />
        <p>
          Supports the normal production of inflammatory factors at the genetic
          level. Helps maintain nitric levels to support blood flow and
          healing.*
        </p>
        <h4 className={styles.header}>RESVERATROL</h4>
        <hr />
        <p>
          Potent anti-oxidant offers broad-spectrum support for the body's
          normal inflammatory response and blood vessel health. Enhances SIRT-1
          (the longevity enzyme) activity and promotes healthy cell
          proliferation.*
        </p>
        <h4 className={styles.header}>OMEGA-3</h4>
        <hr />
        <p>
          Highly concentrated EPA/DHA supports modulation of gene expression
          involved in healthy inflammatory balance and tissue health to support
          a normal pain response to exercise.*
        </p>
        <h4 className={styles.header}>TURMERIC</h4>
        <hr />
        <p>
          Provides Curcumin with three times the normal absorption of regular
          curcumin. Produces Curcumin phytosome for enhanced absorption and
          bioavailability, providing maximal support for healthy inflammatory
          response through multiple pathways.*
        </p>
      </div>
    );
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        // onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.modalView}>{facts()}</div>
        </Fade>
      </Modal>
    </div>
  );
}
